module.exports = __webpack_public_path__ + "img/iRedMail.6b8ae39.svg";